/*eslint-disable */

import { bus } from '@/main';
import toast from '@/services/toast';

export default {
  name: 'restore-data-popup',
  components: {},
  props: ['restoreDataID'],
  data () {
    return {
      isSubmitted:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    closeRemoveItemModalFun(){
      bus.$emit('restoreDataStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    confirmDataDeleteMethod(){
      this.isSubmitted = true
      this.$store.dispatch("dataRestoreByIdAction", {id:this.restoreDataID}).then((res) => {
        this.isSubmitted = false
        toast.success("Data restore successfully");
        this.closeRemoveItemModalFun();
      }).catch((err) => {
        toast.error(err.data.user_msg || err.msg);
        this.isSubmitted = false
      })
    }
  }
}